<template>
  <div
    class="ui-nav-list-item"
    :class="[{ 'ui-nav-list-item--clickable': clickable, active }, customClass]"
    role="button"
    tabindex="0"
    @click="handleClick"
    @keydown.enter.prevent="handleClick"
    @keydown.space.prevent="handleClick"
  >
    <i v-if="icon" :class="icon" aria-hidden="true"></i>
    <span class="ui-nav-list-item__text"><slot>{{ label }}</slot></span>
    <span v-if="showArrow" class="ui-nav-list-item__arrow" aria-hidden="true">→</span>
  </div>
</template>

<script>
export default {
  name: 'NavListItem',
  props: {
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['click'],
  methods: {
    handleClick(event) {
      if (!this.clickable) return;
      this.$emit('click', event);
    },
  },
};
</script>

<style src="../styles/NavListItem.css"></style>
